// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showall{display:inline}aside{position:fixed;padding:.375rem .75rem;background-color:#fff;border:1px solid #ced4da;margin-top:5px;border-radius:.25rem;font-size:.8rem}@media(min-width:768px){aside{right:23px;font-size:1rem}}aside ul{margin:5px 0;flex-direction:column}aside>span{color:#000}aside a{color:#396}", ""]);
// Exports
module.exports = exports;
